import formatDate from '@/utils/formatDate'

var dateUtil = {
	/**
	 * ���ڷ�Χ������
	 */
	startTime: function(time) {
		const nowTimeDate = new Date(time)
		return formatDate(new Date(nowTimeDate.setHours(0, 0, 0, 0)), 'yyyy/MM/dd HH:mm:ss');
	},

	endTime: function(time) {
		const nowTimeDate = new Date(time)
		return formatDate(new Date(nowTimeDate.setHours(23, 59, 59, 999)), 'yyyy/MM/dd HH:mm:ss');
	},

	/***
	 * ��ǰʱ��
	 */
	getCurrentDate: function() {
		return new Date();
	},

	/***
	 * ����Ŀ�ʼʱ��
	 */
	getBeginToday: function() {
		return new Date(new Date(new Date().toLocaleDateString()).getTime());
	},

	/***
	 * ��һ��ʱ��
	 */
	getYesterday: function(date) {
		var currentDate = dateUtil.getCurrentDate();
		if (date) {
			if (typeof(date) == "string") {
				currentDate = new Date(date)
			} else {
				currentDate = date
			}
		}
		return new Date(new Date(currentDate.toLocaleDateString()).getTime()) - 24 * 60 * 60 * 1000;
	},

	/***
	 * ��һ��ʱ��
	 */
	getNextday: function(date) {
		var currentDate = dateUtil.getCurrentDate();
		if (date) {
			if (typeof(date) == "string") {
				currentDate = new Date(date)
			} else {
				currentDate = date
			}
		}
		return new Date(new Date(currentDate.toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000);
	},

	/***
	 * ���ܵĵ�һ��ʱ��
	 */
	getBeginWeek: function() {
		var currentDate = dateUtil.getCurrentDate();
		var week = currentDate.getDay();

		//һ��ĺ�����
		var millisecond = 1000 * 60 * 60 * 24;
		//��ȥ������
		var minusDay = week != 0 ? week - 1 : 6;
		//���� ��һ
		var monday = new Date(currentDate.getTime() - (minusDay * millisecond));
		return dateUtil.startTime(monday);
	},

	/***
	 * ���ܵ����һ��ʱ��
	 */
	getEndWeek: function() {
		var currentDate = dateUtil.getCurrentDate();
		var week = currentDate.getDay();
		//һ��ĺ�����
		var millisecond = 1000 * 60 * 60 * 24;
		//��ȥ������
		var minusDay = week != 0 ? week - 1 : 6;
		//���� ����
		var monday = new Date(currentDate.getTime() - (minusDay * millisecond));
		var sunday = new Date(monday.getTime() + (6 * millisecond));
		//����
		return dateUtil.endTime(sunday);
	},

	/***
	 * ���ܵĿ�ʼ
	 */
	getBeginLastWeek: function(date) {
		var currentDate = dateUtil.getCurrentDate();
		if (date) {
			if (typeof(date) == "string") {
				currentDate = new Date(date)
			} else {
				currentDate = date
			}
		}
		var first = currentDate.getDate() - currentDate.getDay() - 6;
		var startDate = new Date(currentDate.setDate(first));
		return dateUtil.startTime(startDate);
	},

	/***
	 * ���ܵĽ���
	 */
	getEndLastWeek: function(date) {
		var currentDate = dateUtil.getCurrentDate();
		if (date) {
			if (typeof(date) == "string") {
				currentDate = new Date(date)
			} else {
				currentDate = date
			}
		}
		var first = currentDate.getDate() - currentDate.getDay() - 6;
		var last = first + 6;
		var endDate = new Date(currentDate.setDate(last));
		return dateUtil.endTime(endDate);
	},

	/***
	 * ���ܵĿ�ʼ
	 */
	getBeginNextWeek: function(date) {
		var currentDate = dateUtil.getCurrentDate();
		if (date) {
			if (typeof(date) == "string") {
				currentDate = new Date(date)
			} else {
				currentDate = date
			}
		}
		var first = currentDate.getDate() + currentDate.getDay() + 6;
		var startDate = new Date(currentDate.setDate(first));
		return dateUtil.startTime(startDate);
	},

	/***
	 * ���ܵĽ���
	 */
	getEndNextWeek: function(date) {
		var currentDate = dateUtil.getCurrentDate();
		if (date) {
			if (typeof(date) == "string") {
				currentDate = new Date(date)
			} else {
				currentDate = date
			}
		}
		var first = currentDate.getDate() + currentDate.getDay() + 6;
		var last = first + 6;
		var endDate = new Date(currentDate.setDate(last));
		return dateUtil.endTime(endDate);
	},

	/***
	 * ���µĵ�һ��ʱ��
	 */
	getBeginMonth: function() {
		var currentDate = dateUtil.getCurrentDate();
		var currentMonth = currentDate.getMonth();
		//��õ�ǰ���4λ��
		var currentYear = currentDate.getFullYear();
		//������µ�һ��
		var firstDay = formatDate(new Date(currentYear, currentMonth, 1), 'yyyy/MM/dd HH:mm:ss');

		return firstDay;
	},

	/***
	 * ���µ����һ��ʱ��
	 */
	getEndMonth: function() {
		//��ȡ��ǰʱ��
		var currentDate = dateUtil.getCurrentDate();
		var fullYear = currentDate.getFullYear();
		var month = currentDate.getMonth() + 1; // getMonth �������� 0-11������1-12��
		var endOfMonth = new Date(fullYear, month, 0);
		return dateUtil.endTime(endOfMonth);
	},

	/***
	 * ���µĵ�һ��ʱ��
	 */
	getBeginLastMonth: function(date) {
		//��ȡ��ǰʱ��
		var currentDate = dateUtil.getCurrentDate();
		if (date) {
			if (typeof(date) == "string") {
				currentDate = new Date(date)
			} else {
				currentDate = date
			}
		}
		//��õ�ǰ�·�0-11
		var currentMonth = currentDate.getMonth();
		//��õ�ǰ���4λ��
		var currentYear = currentDate.getFullYear();
		//�����һ���µĵ�һ��
		var priorMonthFirstDay = dateUtil.getPriorMonthFirstDay(currentYear, currentMonth);
		return priorMonthFirstDay;
	},

	/***
	 * ���µ����һ��ʱ��
	 */
	getEndLastMonth: function() {
		//һ��ĺ�����
		var millisecond = 1000 * 60 * 60 * 24;
		//������µ����һ��
		var lastDay = new Date(new Date(dateUtil.getBeginMonth()).getTime() - millisecond);

		return dateUtil.endTime(lastDay);
	},

	/**
	 * ������һ���µĵ�һ��Date����
	 * @param year ��
	 * @param month ��
	 **/
	getPriorMonthFirstDay: function(year, month) {
		//���Ϊ0����,�Ǳ���ĵ�һ��,���Բ��ܼ�
		if (month == 0) {
			month = 11; //�·�Ϊ���������·�
			year--; //��ݼ�1
			return formatDate(new Date(year, month, 1), 'yyyy/MM/dd HH:mm:ss');
		}
		//����,ֻ��ȥ�·�
		month--;
		return formatDate(new Date(year, month, 1), 'yyyy/MM/dd HH:mm:ss');
	},

	/***
	 * ���µĵ�һ��ʱ��
	 */
	getBeginNextMonth: function(date) {
		//��ȡ��ǰʱ��
		var currentDate = dateUtil.getCurrentDate();
		if (date) {
			if (typeof(date) == "string") {
				currentDate = new Date(date)
			} else {
				currentDate = date
			}
		}
		//��õ�ǰ�·�0-11
		var currentMonth = currentDate.getMonth();
		//��õ�ǰ���4λ��
		var currentYear = currentDate.getFullYear();

		//���Ϊ0����,�Ǳ���ĵ�һ��,���Բ��ܼ�
		if (currentMonth == 11) {
			currentMonth = 0; //�·�Ϊ���������·�
			currentYear++; //��ݼ�1
			return formatDate(new Date(currentYear, currentMonth, 1), 'yyyy/MM/dd HH:mm:ss');
		}
		//����,ֻ��ȥ�·�
		currentMonth++;
		return formatDate(new Date(currentYear, currentMonth, 1), 'yyyy/MM/dd HH:mm:ss');
	},

	/***
	 * ���µ����һ��ʱ��
	 */
	getEndNextMonth: function(date) {
		//��ȡ��ǰʱ��
		var currentDate = dateUtil.getCurrentDate();
		if (date) {
			if (typeof(date) == "string") {
				currentDate = new Date(date)
			} else {
				currentDate = date
			}
		}
		//��õ�ǰ�·�0-11
		var currentMonth = currentDate.getMonth() + 1;
		//��õ�ǰ���4λ��
		var currentYear = currentDate.getFullYear();

		//���Ϊ0����,�Ǳ���ĵ�һ��,���Բ��ܼ�
		if (currentMonth == 12) {
			currentMonth = 1; //�·�Ϊ���������·�
			currentYear++; //��ݼ�1
			return formatDate(new Date(currentYear, currentMonth, 0), 'yyyy/MM/dd HH:mm:ss');
		}
		//����,ֻ��ȥ�·�
		currentMonth++;
		return formatDate(new Date(currentYear, currentMonth, 0), 'yyyy/MM/dd HH:mm:ss');
	},

	/**
	 * ���ر����ȵ�һ��
	 **/
	getCurrentQuarterStartDate: function() {
		let now = new Date(); //��ǰ���� 
		let nowMonth = now.getMonth(); //��ǰ�� 
		let nowYear = now.getFullYear(); //��ǰ�� 
		let jd = Math.ceil((nowMonth + 1) / 3);
		return formatDate(new Date(nowYear, (jd - 1) * 3, 1), 'yyyy/MM/dd HH:mm:ss');
	},

	/**
	 * ���ر����ȵ����һ��
	 **/
	getCurrentQuarterEndDate: function() {
		let now = new Date(); //��ǰ���� 
		let nowMonth = now.getMonth(); //��ǰ�� 
		let nowYear = now.getFullYear(); //��ǰ�� 
		let jd = Math.ceil((nowMonth + 1) / 3);
		return dateUtil.endTime(new Date(nowYear, jd * 3, 0));
	},

	getCurrentYearStartDate: function() {
		let now = new Date(); //��ǰ���� 
		let nowYear = now.getFullYear(); //��ǰ�� 
		return formatDate(new Date(nowYear, 0, 1), 'yyyy/MM/dd HH:mm:ss');
	},

	getCurrentYearEndDate: function() {
		let now = new Date(); //��ǰ���� 
		let nowYear = now.getFullYear(); //��ǰ�� 
		return dateUtil.endTime(new Date(nowYear, 11, 31));
	},

	getLastYearStartDate: function(date) {
		//��ȡ��ǰʱ��
		var currentDate = dateUtil.getCurrentDate();
		if (date) {
			if (typeof(date) == "string") {
				currentDate = new Date(date)
			} else {
				currentDate = date
			}
		}
		let lastYear = currentDate.getFullYear() - 1; //��ǰ�� 
		return formatDate(new Date(lastYear, 0, 1), 'yyyy/MM/dd HH:mm:ss');
	},

	getLastYearEndDate: function(date) {
		//��ȡ��ǰʱ��
		var currentDate = dateUtil.getCurrentDate();
		if (date) {
			if (typeof(date) == "string") {
				currentDate = new Date(date)
			} else {
				currentDate = date
			}
		}
		let lastYear = currentDate.getFullYear() - 1; //��ǰ�� 
		return dateUtil.endTime(new Date(lastYear, 11, 31));
	},

	getNextYearStartDate: function(date) {
		//��ȡ��ǰʱ��
		var currentDate = dateUtil.getCurrentDate();
		if (date) {
			if (typeof(date) == "string") {
				currentDate = new Date(date)
			} else {
				currentDate = date
			}
		}
		let nextYear = currentDate.getFullYear() + 1; //��ǰ�� 
		return formatDate(new Date(nextYear, 0, 1), 'yyyy/MM/dd HH:mm:ss');
	},

	getNextYearEndDate: function(date) {
		//��ȡ��ǰʱ��
		var currentDate = dateUtil.getCurrentDate();
		if (date) {
			if (typeof(date) == "string") {
				currentDate = new Date(date)
			} else {
				currentDate = date
			}
		}
		let nextYear = currentDate.getFullYear() + 1; //��ǰ�� 
		return dateUtil.endTime(new Date(nextYear, 11, 31));
	},

	getLevelDate: function(start, end) {
		let levelDate = [];
		let startTime = new Date(start).getTime();
		let endTime = new Date(end).getTime();
		for (var k = startTime; k <= endTime;) {
			levelDate.push(formatDate(new Date(parseInt(k)), 'yyyy/MM/dd'));
			k = k + 24 * 60 * 60 * 1000;
		}
		return levelDate;
	},
	getLastCustomCycle(start, end) {
		if (typeof(start) == "string") {
			start = new Date(start)
		}
		if (typeof(end) == "string") {
			end = new Date(end)
		}
		let dateDiff = end.getTime() - start.getTime();
		let startDate = new Date(start.getTime() - dateDiff);
		return [dateUtil.startTime(startDate),dateUtil.endTime(start)]
	}
};

export default dateUtil;